export const FORM_NAME = 'BATCH_ORDERS';

export const FILES_TEMPLATE = {
  CREATE_BATCH_ORDERS: 'https://static.525k.io/masheed-batch-files/sa/sales-orders-batch.xlsx',
  CREATE_BATCH_FORECAST_ORDERS: 'https://static.525k.io/masheed-batch-files/sa/forecast-batch.xlsx',
  ASSIGN_BATCH_FORECAST_ORDERS:
    'https://static.525k.io/masheed-batch-files/sa/assign-forecast-batch.xlsx',
};
